module.exports = __webpack_public_path__ + "static/media/mono_manual_west_coast.b604ca85.svg";